export default "__VITE_ASSET__uv1aS_be__"